<template>
    <note-modal
            :sentNoteFn="escalateQuery"
            :show.sync="visible"
            button-text="Escalate query"
            error-message="Please enter a message"
            note-placeholder="Write a message..."
            title="Escalate query"
            :busy="loading"
    >
        <b-alert :show="!hasOptions && !loading"
                 variant="danger"
        >
            There are currently no managers to escalate this query to.
        </b-alert>
        <div v-if="hasOptions" class="mb-3 small">
            <b-form-group
                    label="Send query to:"
                    label-size="sm"
            >
                <b-input-group>
                    <assign-select
                            v-if="options.length > 0"
                            :options="options"
                            v-model="form.recipient"
                    >
                    </assign-select>
                    <div v-else-if="form.recipient !== null"
                         class="b-form-group-content">
                        {{ form.recipient.firstName + ' ' + form.recipient.lastName }}
                    </div>
                </b-input-group>
            </b-form-group>
            <font-awesome-icon
                    class="mr-2"
                    :icon="['fa', 'question-circle']">
            </font-awesome-icon>
            This query will be escalated to this team manager.
        </div>
    </note-modal>
</template>

<script>
import NoteModal from '@/components/Action/Modal/NoteModal';
import Action from '@/services/Action/Action';
import ErrorMixin from '@/components/Notifications/ErrorMixin';
import AssignSelect from '@/components/Form/AssignSelect';

export default {
  name: 'Escalate-Query-Modal',
  components: {
    NoteModal,
    AssignSelect,
  },
  props: {
    clientActionId: {
      required: true,
    },
    show: {
      required: true,
    },
    model: {
      required: false,
      default: () => Action,
    },
  },
  mixins: [ErrorMixin],
  data() {
    return {
      loading: false,
      options: [],
      visible: true,
      form: {
        recipient: null,
      },
    };
  },
  computed: {
    hasOptions() {
      return this.options.length > 0 || this.form.recipient;
    },
  },
  watch: {
    visible(newVisible) {
      if (!newVisible) {
        this.$emit('update:show');
      }
    },
  },
  created() {
    this.visible = this.show;
  },
  mounted() {
    this.setOptions();
  },
  methods: {
    async escalateQuery({ note }) {
      if (!this.form.recipient) {
        this.notifyError('Please select a team manager to escalate to');
        return;
      }
      this.loading = true;

      const { teamId, userId } = this.form.recipient;

      const params = {
        clientActionId: this.clientActionId,
        query: note,
        teamId,
        userId,
      };

      try {
        await this.model.escalateQuery(params);

        const title = 'Query escalated';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          type,
        });

        this.visible = false;
        this.$store.dispatch('refreshAction');
        this.$store.dispatch('refreshActions');
        this.$emit('submitted', true);
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    async setOptions() {
      this.loading = true;
      try {
        const { data } = await this.model.getTeamManagers(this.clientActionId);

        const { managers } = data.data;

        const options = [];

        if (managers.length > 0) {
          if (managers.length === 1) {
            const onlyManager = managers[0];
            onlyManager.teamId = onlyManager.team.teamId;
            this.form.recipient = onlyManager;
            return;
          }

          const items = [];
          managers.forEach((manager) => {
            const { team } = manager;

            if (!items[team.teamId]) {
              items[team.teamId] = [];
            }

            items[team.teamId].push({
              label: `${manager.firstName} ${manager.lastName}`,
              userId: manager.userId,
              user: manager.userId,
              teamId: team.teamId,
              team: team.team,
            });
          });

          items.forEach((teamManagers) => {
            const name = teamManagers[0].team;
            options.push({
              team: `${name} managers`,
              items: teamManagers,
            });
          });
        }

        this.options = options;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

  },
};
</script>
